export default __webpack_public_path__ + "static/media/vectorglobal.b5018f31.png";